import styled from 'styled-components';

export const ResumoParcelasSelecionadasMobile = styled.div`
  display: none;
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 1;
  background-color: white;

  @media (max-width: 820px) {
    display: block;
  }
`;

export const ParcelaSelecionadaMobile = styled.div`
  background-color: ${(props) => props?.tema?.primaryColor};
  border: 2px solid ${(props) => props?.tema?.primaryColor};
  border-top-left-radius: 16px;
  width: 40%;
  height: 60px;
  box-sizing: border-box;
  font-size: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-weight: bold;
`;

export const FirstSectionMobile = styled.div`
  display: flex;
  border: 1px solid ${(props) => props?.tema?.primaryColor};
  border-radius: 16px 16px 0px 0px;
`;

export const SecondSectionMobile = styled.div`
  padding-top: 10px;
  padding-left: 16px;
  border: 1px solid ${(props) => props?.tema?.primaryColor};
  border-top-width: 0;

  div {
    border: none;
  }

  .paymentTitle {
    font-size: 16px;
    display: block;
    margin-bottom: 4px;
    font-weight: bold;
    color: #4d4d4d;
  }
`;
